module.exports = __webpack_public_path__ + "img/phone3.3eb05949.png";